import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import CustomDialog from "global/components/CustomDialog/CustomDialog";
import { handleErrorMessage, openSuccessNotification } from "helpers/methods";
import { useState } from "react";
import { unsubscribeContactById } from "../ViewContactService";
import CustomLoader from "global/components/CustomLoader/CustomLoader";

interface CustomProps {
  isVisible: boolean;
  handleDialogClose: Function;
  contact: any;
  getContactData: any;
}

const ContactStatusChangeModal = (props: CustomProps) => {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleUnsubscribeContact = async () => {
    try {
      setIsLoading(true);
      const res = await unsubscribeContactById(props?.contact.id);
      openSuccessNotification(res.message);
      setIsLoading(false);
      props.handleDialogClose();
      await props.getContactData();
    } catch (error: any) {
      setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const getDialogHeader = () => {
    return (
      <>
        <Box display="flex" justifyContent="center" pt={3}>
          <Typography variant="h4" color={theme.palette.primary.main}>
            Unsubscribe Contact
          </Typography>
        </Box>
      </>
    );
  };

  const getBody = () => {
    return (
      <>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          p={1}
        >
          <Typography textAlign="center">
            Are you sure you want to remove{" "}
            <span style={{ fontWeight: 700 }}>{props.contact?.emailId}</span>{" "}
            from your subscription list? Once unsubscribed, they will no longer
            receive emails.
          </Typography>
        </Box>
      </>
    );
  };
  const getFooter = () => {
    return (
      <Stack direction="row" spacing={2}>
        <Button
          id="contacts_add__cancel_btn"
          variant="outlined"
          sx={{
            width: "7.125rem",
            height: "2.5rem",
          }}
          onClick={() => handleUnsubscribeContact()}
        >
          Yes
        </Button>
        <Button
          id="contacts_add_save_btn"
          variant="contained"
          onClick={() => props.handleDialogClose()}
          sx={{
            width: "7.125rem",
            height: "2.5rem",
          }}
        >
          No
        </Button>
      </Stack>
    );
  };

  return (
    <>
      <CustomLoader isLoading={isLoading} />
      <CustomDialog
        handleDialogClose={props.handleDialogClose}
        isDialogOpen={props.isVisible}
        title={getDialogHeader()}
        body={getBody()}
        footer={getFooter()}
        closeButtonVisibility={true}
        closable
      />
    </>
  );
};

export default ContactStatusChangeModal;
